module.exports = __webpack_public_path__ + "img/reference48.18fafe72.jpg";